import { defineStore } from "pinia";
import { ref } from "vue";
import { storage } from "/@/cool/utils";
import { normalizeLang } from "/@/utils/normalizeLang";
const data = storage.info();

const ZHCN = "zh-CN";
const EN = "en";

export const useLangStore = defineStore("lang", function () {
	// 基本信息
	const info = ref<String>(normalizeLang(data.lang || data.i18nextLng) || ZHCN);
	const list = ref<String[]>([ZHCN, EN]);
	// 设置基本信息
	function set(data: string) {
		info.value = normalizeLang(data);
		storage.set("lang", info.value);
		storage.set("i18nextLng", info.value);
	}

	function get() {
		return info.value;
	}

	function isZh() {
		return info.value === ZHCN;
	}

	function switchLang() {
		if (info.value == ZHCN) {
			set(EN);
		} else {
			set(ZHCN);
		}
	}

	return {
		info,
		set,
		list,
		isZh,
		get,
		switchLang
	};
});
